import { ShoppingCart } from '@cinemark/checkout-api-client';

export const getShoppingCartItemCount = (cart: ShoppingCart | null, isFamilyEntertainmentCenter = false): number => {
  if (!cart) {
    return 0;
  }

  if (isFamilyEntertainmentCenter) {
    return (cart.familyEntertainmentCenterConcessions ?? []).reduce((sum, concession) => sum + concession.quantity, 0);
  }

  return cart.showtimes.reduce((sum, showtime) => {
    const ticketCount = showtime.tickets.reduce((ticketSum, ticket) => ticketSum + ticket.quantity, 0);
    const concessionCount = showtime.concessions.reduce((concessionSum, concession) => concessionSum + concession.quantity, 0);
    return sum + ticketCount + concessionCount;
  }, 0);
};

export const removeShoppingCartTicket = (cart: ShoppingCart, showtimeId: number, ticketId: string): ShoppingCart => {
  return {
    ...cart,
    showtimes: cart.showtimes
      .map(showtime => showtime.showtimeId === showtimeId ? {
        ...showtime,
        tickets: showtime.tickets.filter(ticket => ticket.id !== ticketId),
      } : showtime)
      .filter(showtime => showtime.tickets.length > 0 || showtime.concessions.length > 0),
  };
};
